<template>
  <div class="store-locator-wrapper">

    <form @submit.prevent="searchStores" id="formSearchStores" class="d-flex justify-content-center align-items-end needs-validation" novalidate>
      <div class="wrapper">
        <label for="cep_city">Cidade ou CEP</label>
        <div class="wrap">
          <input
            v-model="cep_city"
            type="text"
            :class="['form-control', 'form-search', { 'is-invalid': input_invalid }]"
            name="cep_city"
            id="cep_city"
            placeholder="Digite a cidade ou CEP"
            required
            @input="validateInput"
          />
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.34794 8.69588C3.1338 8.69588 2.10561 8.27476 1.26337 7.43252C0.421124 6.59027 0 5.56208 0 4.34794C0 3.1338 0.421124 2.1056 1.26337 1.26335C2.10561 0.421118 3.1338 0 4.34794 0C5.56208 0 6.59027 0.421118 7.43252 1.26335C8.27477 2.1056 8.69589 3.1338 8.69589 4.34794C8.69589 4.85565 8.61066 5.34058 8.4402 5.80273C8.26975 6.26487 8.04232 6.66685 7.75792 7.00867L11.8489 11.0996C11.9473 11.198 11.9977 11.3218 11.9999 11.4708C12.0022 11.6198 11.9519 11.7458 11.8489 11.8488C11.7458 11.9518 11.621 12.0033 11.4742 12.0033C11.3275 12.0033 11.2026 11.9518 11.0996 11.8488L7.00867 7.75792C6.65317 8.05143 6.24436 8.28113 5.78221 8.44703C5.32007 8.61293 4.84198 8.69588 4.34794 8.69588ZM4.34794 7.62943C5.26402 7.62943 6.03996 7.31154 6.67575 6.67575C7.31154 6.03996 7.62943 5.26402 7.62943 4.34794C7.62943 3.43185 7.31154 2.65592 6.67575 2.02013C6.03996 1.38434 5.26402 1.06645 4.34794 1.06645C3.43185 1.06645 2.65592 1.38434 2.02013 2.02013C1.38435 2.65592 1.06646 3.43185 1.06646 4.34794C1.06646 5.26402 1.38435 6.03996 2.02013 6.67575C2.65592 7.31154 3.43185 7.62943 4.34794 7.62943Z" fill="#202AD0"/>
          </svg>
          <div class="invalid-feedback d-block" v-if="input_invalid">
            Cidade ou CEP incorreto, tente novamente.
          </div>
          <div class="invalid-feedback d-block" v-if="request_invalid">
            Não foi possível realizar a requisição. Por favor, tente novamente.
          </div>
        </div>
      </div>
      <button type="submit" class="btn btn-blue btn-lg" id="btnSubmitCep" :disabled="cep_city === ''">
        <span v-show="!isLoading">Buscar</span>
        <span v-show="isLoading">Buscando...</span>
      </button>
    </form>

    <div class="stores-results" v-if="stores.length > 0">
      <p>Resultados da busca:</p>

      <div class="stores-results-list">
        <div v-for="store in stores" :key="store.code" class="stores-results-item d-flex flex-column justify-content-between">
          <div class="wrap">
            <h4>{{ store.name }}</h4>
            <p>{{ store.address }}<br>
              {{ store.city }}<br>
              {{ store.phone }}</p>
          </div>
          <a href="https://api.whatsapp.com/send/?phone=551221360100&text=Oi%21+Vim+do+%23sitedadm+e+quero+fazer+meu+cart%C3%A3o+de+loja&type=phone_number&app_absent=0"
          class="btn btn-outline-light">Fazer cartão</a>
        </div>
      </div>
      <div class="text-center mt-3">
        <button @click="showAll" class="btn text-link-dark" v-if="!showAllStores">Ver mais resultados</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const cep_city = ref('');
const isLoading = ref(false);
const showAllStores = ref(false);

const input_invalid = ref(false);
const request_invalid = ref(false);

const storesAll = ref([]);
const stores = ref([]);

async function searchStores() {

  /**
   * Evita múltiplos cliques
   */
  if (isLoading.value) {
    return;
  }

  showAllStores.value = false;
  storesAll.value = [];
  stores.value = [];

  isLoading.value = true;

  request_invalid.value = false;
  input_invalid.value = false;

  try {

    const params = new URLSearchParams();

    params.append(
      'action',
      'store_locator'
    );

    params.append(
      'nonce',
      frontend_ajax_object.nonce
    );

    params.append(
      'cep_city',
      cep_city.value
    );

    const response = await fetch(
      frontend_ajax_object.ajaxurl,
      {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/x-www-form-urlencoded'
        },
        body: params
      }
    );

    /**
     * Erro HTTP
     */
    if (!response.ok) {

      console.error(
        'Erro HTTP:',
        response.status
      );

      request_invalid.value = true;

      return;
    }

    const data = await response.json();

    /**
     * Erro retornado pelo backend
     */
    if (!data.success) {

      console.error(
        'Erro backend:',
        data
      );

      input_invalid.value = true;

      return;
    }

    /**
     * Estrutura inválida
     */
    if (
      !data.data ||
      !data.data.stores
    ) {

      request_invalid.value = true;

      return;
    }

    storesAll.value = data.data.stores;

    stores.value =
      storesAll.value.slice(0, 4);

  } catch (error) {

    console.error(
      'Erro na requisição:',
      error
    );

    request_invalid.value = true;

  } finally {

    isLoading.value = false;
  }
}

function showAll() {

  stores.value = storesAll.value;

  showAllStores.value = true;
}

function validateInput() {

  if (
    cep_city.value.trim() !== ''
  ) {

    input_invalid.value = false;
    request_invalid.value = false;
  }
}
</script>
